// extracted by mini-css-extract-plugin
export default {"container":"ParticlesBackground_container__V4ETR"};